import {openDialog} from 'platform/components';

import type {AdvertisingPlatformCodeEnum} from '@dms/api/shared';
import i18n from '@dms/i18n';
import {testIds} from '@dms/routes';

import {PlatformEdit} from '../components/PlatformEdit';
import {useConfirmUnsavedGeneralChangesBeforeOpen} from './useConfirmUnsavedGeneralChangesBeforeOpen';

interface OpenPlatformDetailProps {
  vehicleId: string;
  isDisabled: boolean;
}

export function useOpenPlatformDetail(props: OpenPlatformDetailProps) {
  const confirmBeforeOpen = useConfirmUnsavedGeneralChangesBeforeOpen();

  return (platformCode: AdvertisingPlatformCodeEnum, platformTitle: string) => {
    confirmBeforeOpen(
      () =>
        openDialog(
          <PlatformEdit
            vehicleId={props.vehicleId}
            platformCode={platformCode}
            platformName={platformTitle}
            isDisabled={props.isDisabled}
          />,
          {title: i18n.t('entity.vehicle.labels.listingAttributes') + ` "${platformTitle}"`}
        ),
      testIds.vehicles.publishing(`${platformCode}-confirm-unsaved-general-changes`)
    );
  };
}
